<div class="zonaTrabajoComponente">
  <div class="encabezadosComponente">
    <div class="tituloComponente">
      <ng-content select="[titulo]"></ng-content>
    </div>
    <div class="filtrosComponente"
    [style.--filter-width.px]="filterWidth">
       <ng-content select="[filtros]"></ng-content>
    </div>
    <div class="borradorComponente">
       <ng-content select="[borrador]"></ng-content>
    </div>
  </div>
  <div class="contenidoComponente">
      <ng-content select="[contenido]"></ng-content>
  </div>
</div>